module.exports = __webpack_public_path__ + "img/ceo.24a501d7.jpg";